import { render, staticRenderFns } from "./InvoiceDialog.vue?vue&type=template&id=45b153b0&scoped=true"
import script from "./InvoiceDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDialog.vue?vue&type=style&index=0&id=45b153b0&prod&lang=scss&scoped=true"
import style1 from "./InvoiceDialog.vue?vue&type=style&index=1&id=45b153b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b153b0",
  null
  
)

export default component.exports